/* jshint esversion: 6 */

import {EncryptionModifier} from "encryption/EncryptionModifier";
import {Ascii} from "common/Ascii";

const DEFAULT_CRYPT_TOKEN = EncryptionModifier.getDefaultCryptToken(),
    CODE_OR_VAL = EncryptionModifier.getCodeOrVal();

export function decryptData( data, cryptToken = DEFAULT_CRYPT_TOKEN, useLegacyEncoder = true ) {

    if (!data || typeof data !== "string") {
        return "";
    }

    if (!isEncrypted( data, cryptToken )) {
        return data;
    }

    return decrypt( data, useLegacyEncoder );
}

function decryptCharsFromMap(encrypted) {
    encrypted = encrypted.substring(1);
    const hexMap = EncryptionModifier.getHexMap();
    hexMap.forEach((value, key) => {
        const regExp = createCharRegExp(value);
        encrypted = encrypted.replace(regExp, key);
    });
    return encrypted;
}

function createCharRegExp(value) {
    const charCode = value.charCodeAt(0),
        pattern = Ascii.isLetter(charCode) ? value : `\\${value}`;

    return new RegExp(pattern, "g");
}

function getCharsWithPercentage(data) {
    let encodedWithPercent = "";
    for (let i = 0; i < data.length; i += 2) {
        encodedWithPercent += `%${data.substring(i, i + 2)}`;
    }
    return encodedWithPercent;
}

function isEncrypted( data, cryptToken ) {
    return data.charAt(0).charCodeAt(0) === cryptToken;
}

function decrypt( data, useLegacyEncoder ) {
    let decrypt = decryptCharsFromMap(data);
    decrypt = getCharsWithPercentage(decrypt);
    decrypt = useLegacyEncoder ? unescape( decrypt ) : decodeURI( decrypt );
    return shiftLetters(decrypt);
}

function shiftLetters(data) {
    let shiftedData = "";
    for (let i = 0; i < data.length; i++) {
        shiftedData += String.fromCharCode(data.charCodeAt(i) ^ CODE_OR_VAL);
    }
    return shiftedData;
}
